import $ from "jquery";
import Ractive from "ractive";
import _ from "lodash";

/**
 * GenericItemSelector is a modified select box with
 * selectize applied to it.
 * 
 * Selectize only applies to the select box when the 
 * #apply function is called.
 * 
 * @param {string}   - name of the item selection
 * @param {function} - Handle the on change event
 */
module.exports = (name, onChange) => {

    let template = `#${name}-selection`,
        el       = `#${name}-selector`;

    return Ractive.extend({
        template: template,
        apply: function() {
            
            let app          = this.root;
            let $selectorEl  = $(el);

            if (_.isUndefined($selectorEl)) { return; }

            console.debug('#GenericItemSelector@apply - Applying selectize to selectbox');

            $selectorEl.selectize({
                create: false,
                onChange: function(selectedValue) {
                    console.debug('#GenericItemSelector@onChange', selectedValue);
                    onChange(selectedValue, app);
                }
            });

            this.o = $selectorEl[0].selectize;
        }
    });
};